import { isAnimationControls as o } from "./atoms-v2995.js";
import { isVariantLabel as r } from "./atoms-v21105.js";
import { variantProps as t } from "./atoms-v21106.js";
function a(i) {
  return o(i.animate) || t.some((n) => r(i[n]));
}
function f(i) {
  return !!(a(i) || i.variants);
}
export {
  a as isControllingVariants,
  f as isVariantNode
};
